<div class=" section-form">

    <div class="row medium-grey-bg fullheight collapse">
        <div class="medium-5 columns medium-centered long-fade-in">

            <div  [formGroup]="loginForm" class="callout white  padding-center border  medium-grey-bg   form">

                <div class="padding-middles">
                    <div class="login">
                        <div class="section-title margin-bottom-1">
                            DASHBOARD
                        </div>
                        <form class="form margin-bottom-2" [formGroup]="loginForm">
                           <div class="large-text">
                            Email
                           </div>
                            <input formControlName="email" type="text" name="" id="">



                            <div class="large-text">
                                Password
                               </div>
                            <input formControlName="password_hash" type="password">


                        </form>

                        <button [disabled]="!loginForm.valid" (click)="loginAction()"
                            class="button expanded">Login</button>



                    </div>

                </div>
            </div>



        </div>
       

      
    </div>
</div>